<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 230px">
      <div class="left-top" @click="addOrderType">
        <div class="flex-1 font-16-30313a">单据类型</div>
        <div class="tip-20-bg-30313a">
          <i class="el-icon-plus font-bold"></i>
        </div>
      </div>
      <div class="flex-1 h-0" v-if="menuList.length>0">
        <cate-menu :menu-data="menuList" not-add="true" :not-edit="true"  @on-delete="onDeleteClassify" @on-choose="onChooseMenu" :choose-id="chooseMenuId"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 w-0">
      <div style="padding: 10px 20px 20px 0" class="flex-column h-100">
        <div class="flex content-top mb-10">
          <div class="flex-1 bg-ff h-100 flex align-center pl-10 ptb-5">
            <div class="flex align-center mr-20 cursor">
              <div class="mr-5 decoration-line"></div>
              <div class="font-bold font-16-46b8b0">{{currentMenu.name}} - 单据参数定义</div>
            </div>
          </div>
        </div>
        <div class="flex-1" style="border-radius: 10px">
          <div class="h-100 flex-column bg-ff">
            <div class="flex-1 h-0">
              <div class="h-100 p-20">
                <div class="flex mb-10">
                  <!-- <div class="tip-16-round-30313a" style="background: #ff5555" v-if="currentMenu.isRed == 1">
                    退单
                  </div>
                  <div class="tip-16-round-30313a" v-else>
                    正单
                  </div> -->
                  <div class="font-14-30313a font-bold">是否正单：</div>
                  <el-checkbox v-model="data.isRed" :true-label="-1" :false-label="1"><span class="tip-16-round-30313a">正单</span></el-checkbox>
                  <el-checkbox v-model="data.isRed" :true-label="1" :false-label="-1"><span class="tip-16-round-30313a" style="background: #ff5555">退单</span></el-checkbox>
                </div>
                <div class="flex align-center mb-10">
                  <div class="font-14-30313a font-bold">单据名称：</div>
                  <el-input v-model="data.name" style="width: 190px"></el-input>
                </div>
                <div class="flex align-center mb-10">
                  <div class="font-14-30313a font-bold">编码方案：</div>
                  <el-input v-model="data.orderCode" style="width: 70px"></el-input>
                  <!--<div class="font-12-30313a flex-1 text-left">{{data.orderCode}}</div>-->
                </div>
                <div class="flex align-center mb-10">
                  <div class="font-14-30313a font-bold">单据类型：</div>
                  <el-input v-model="data.type" type="number" min="1" max="15" style="width: 70px"></el-input>
                  <div class="flex-1 ml-5 font-12-ff5555 text-left">（单据类型为1~15的整数）</div>
                </div>
                <div class="flex align-center mb-10">
                  <div class="font-14-30313a font-bold">是否库存单：</div>
                  <el-input v-model="data.storehouseFlag" type="number" min="-1" max="2" style="width: 70px"></el-input>
                  <div class="flex-1 ml-5 font-12-ff5555 text-left">（1入库 2出库 -1不是库存单）</div>
                </div>
                <div class="flex align-center mb-10">
                  <div class="font-14-30313a font-bold">单据权限：</div>
                  <el-input v-model="data.permission" style="width: 190px"></el-input>
                  <!--<div class="font-12-30313a flex-1 text-left">{{data.orderCode}}</div>-->
                </div>
                <div class="flex align-center mb-10">
                  <div class="font-14-30313a font-bold">退单关联：</div>
                  <el-select v-model="data.chargebackOrder" placeholder="请选择">
                    <el-option
                      v-for="item in menuList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name">
                    </el-option>
                  </el-select>
                  <div class="btn-24-bg-46b8b0" style="margin-left: 20px" @click="cancelBackOrder">取消关联</div>
                  <!--<el-input v-model="data.chargebackOrder" style="width: 70px"></el-input>-->
                  <!--<div class="font-12-30313a text-left">{{data.chargebackOrder}}</div>-->
                </div>
                <div class="flex align-center border-b-dashed-e2" style="padding-bottom: 20px;">
                  <div class="font-14-30313a font-bold">记账类型：</div>
                  <el-select v-model="data.accountingTypeName" placeholder="请选择">
                    <el-option
                      v-for="item in accountType"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                  <div class="font-12-30313a mr-10" style="margin-left: 20px">供应商结账</div>
                  <el-checkbox v-model="data.isCheckOut" :true-label="1" :false-label="-1"></el-checkbox>
                  <!--<div class="font-12-30313a text-left">{{data.accountingType === 'auxiliary' ? '辅材' : data.accountingType === 'project' ? '主材' : data.accountingType === 'soft' ? '软装' : ''}}</div>-->
                </div>
                <div class="ptb-20 border-b-dashed-e2 flex align-center">
                  <div class="font-14-30313a font-bold">材料开单比例：</div>
                  <el-input v-model="data.orderProportion" type="number" style="width: 70px"></el-input>
                  <div class="flex-1 ml-5 font-12-ff5555 text-left">（比例为0时不控制）</div>
                </div>
                <div class="ptb-20 border-b-dashed-e2">
                  <div class=" flex align-center">
                    <div class="font-14-30313a font-bold">数据只来源于单据：</div>
                    <el-checkbox v-model="data.isSourceOrder" :true-label="1" :false-label="-1"></el-checkbox>
                    <div class="flex-1"></div>
                  </div>
                  <div v-if="data.isSourceOrder === 1" class="flex align-center mt-10">
                    <div class="font-14-30313a font-bold">来源单据：</div>
                    <el-select v-model="data.sourceOrderId" placeholder="请选择">
                      <el-option
                        v-for="item in orderDefineList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                    <div class="flex-1"></div>
                  </div>
                </div>
                <div class="ptb-20 border-b-dashed-e2 flex align-center">
                  <div class="font-14-30313a font-bold">采购价/成本价：</div>
                  <el-select v-model="data.costPriceField" placeholder="请选择">
                    <el-option
                      v-for="item in priceList"
                      :key="item.priceField"
                      :label="item.name"
                      :value="item.priceField">
                    </el-option>
                  </el-select>
                  <div class="font-12-30313a mr-10" style="margin-left: 20px">新增时允许修改</div>
                  <el-checkbox v-model="data.costPriceAdd" :true-label="1" :false-label="-1"></el-checkbox>
                  <div class="font-12-30313a mr-10" style="margin-left: 20px">修改时允许修改</div>
                  <el-checkbox v-model="data.costPriceModify" :true-label="1" :false-label="-1"></el-checkbox>
                </div>
                <div class="flex align-center mt-10 ptb-20">
                  <div class="font-14-30313a font-bold">销售价：</div>
                  <el-select v-model="data.customerPriceField" placeholder="请选择">
                    <el-option
                      v-for="item in priceList"
                      :key="item.priceField"
                      :label="item.name"
                      :value="item.priceField">
                    </el-option>
                  </el-select>
                  <div class="font-12-30313a mr-10" style="margin-left: 20px">新增时允许修改</div>
                  <el-checkbox v-model="data.customerPriceAdd" :true-label="1" :false-label="-1"></el-checkbox>
                  <div class="font-12-30313a mr-10" style="margin-left: 20px">修改时允许修改</div>
                  <el-checkbox v-model="data.customerPriceModify" :true-label="1" :false-label="-1"></el-checkbox>
                  <div class="flex-1"></div>
                </div>
              </div>
            </div>
            <div style="height: 50px; border-top: 1px solid #e2e2e2" class="flex align-center justify-center">
              <div class="btn-30-border-85 mr-10" @click="getData">重置</div>
              <div class="btn-30-bg-46b8b0-s" @click="onSave">保存</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="my-dialog" :modal-append-to-body="false" :append-to-body="false" :title="title+'单据'" width="457px" :visible.sync="orderType">
      <div style="padding: 20px">
        <div class="bg-ff font-12-ff5555 text-left align-center mb-10">
          <i class="el-icon-warning mr-5"></i>
          提示：标有 * 的为必填项！
        </div>
        <div class="flex align-center mb-10">
          <div class="font-14-30313a font-bold bitian">是否正单：</div>
          <!-- <div class="flex align-center" @click="changeRed(-1)">
            <img :src="isRed == -1 ? '/static/images/xuanzhong.png':'/static/images/weixuan.png'" class="icon-16 ml-10 mr-5" alt="">
            <div class="tip-16-round-30313a mr-10">正单</div>
          </div>
          <div class="flex align-center" @click="changeRed(1)">
            <img :src="isRed == 1 ? '/static/images/xuanzhong.png':'/static/images/weixuan.png'" class="icon-16 ml-10 mr-5" alt="">
            <div class="tip-16-round-30313a" style="background: #ff5555">退单</div>
          </div> -->
          <el-checkbox v-model="red" @change="onChange1"><span class="tip-16-round-30313a">正单</span></el-checkbox>
          <el-checkbox v-model="notRed" @change="onChange2"><span class="tip-16-round-30313a" style="background: #ff5555">退单</span></el-checkbox>
        </div>
        <div class="flex align-center mb-10">
          <div class="font-14-30313a font-bold bitian">单据名称：</div>
          <el-input class="flex-1" v-model="classifyInfo.name" placeholder="请输入"></el-input>
        </div>
        <div class="flex align-center mb-10">
          <div class="font-14-30313a font-bold bitian">编码方案：</div>
          <el-input v-model="classifyInfo.orderCode" class="flex-1"></el-input>
        </div>
        <div class="flex align-center mb-10">
          <div class="font-14-30313a font-bold bitian">单据类型：</div>
          <el-input v-model="classifyInfo.type" type="number" min="1" max="15" class="flex-1"></el-input>
          <div class="flex-1 ml-5 font-12-ff5555 text-left">（单据类型为1~15的整数）</div>
        </div>
        <div class="flex align-center mb-10">
          <div class="font-14-30313a font-bold bitian">是否库存单：</div>
          <el-input v-model="classifyInfo.storehouseFlag" type="number" min="-1" max="2" class="flex-1"></el-input>
          <div class="flex-1 ml-5 font-12-ff5555 text-left">（1入库 2出库 -1不是库存单）</div>
        </div>
        <div class="flex align-center mb-10">
          <div class="font-14-30313a font-bold bitian">单据权限：</div>
          <el-input v-model="classifyInfo.permission" class="flex-1"></el-input>
          <!--<div class="font-12-30313a flex-1 text-left">{{data.orderCode}}</div>-->
        </div>
        <!-- <div class="flex align-center mb-10">
          <div class="font-14-30313a font-bold bitian">退单关联：</div>
          <el-select v-model="classifyInfo.chargebackOrder" placeholder="请选择" class="flex-1">
            <el-option
              v-for="item in menuList"
              :key="item.id"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </div> -->
        <div class="flex align-center mb-10">
          <div class="font-14-30313a font-bold bitian">记账类型：</div>
          <el-select v-model="classifyInfo.accountingTypeName" placeholder="请选择" class="flex-1">
            <el-option
              v-for="item in accountType"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="flex align-center mb-10">
          <div class="font-14-30313a font-bold bitian">采购价/成本价：</div>
          <el-select v-model="classifyInfo.costPriceField" placeholder="请选择" class="flex-1">
            <el-option
              v-for="item in priceList"
              :key="item.priceField"
              :label="item.name"
              :value="item.priceField">
            </el-option>
          </el-select>
        </div>
        <div class="flex align-center">
          <div class="font-14-30313a font-bold bitian">销售价：</div>
          <el-select v-model="classifyInfo.customerPriceField" placeholder="请选择" class="flex-1">
            <el-option
              v-for="item in priceList"
              :key="item.priceField"
              :label="item.name"
              :value="item.priceField">
            </el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="resetClassify">重置</div>
        <div class="btn-30-bg-46b8b0-s" @click="submitClassify">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CateMenu from '../../components/CateMenu'
import MoveHorizon from '../../components/MoveHorizon'
export default {
  name: 'materialOrderDefine',
  components: {CateMenu, MoveHorizon},
  data () {
    return {
      chooseMenuId: null,
      currentMenu: {},
      menuList: [],
      data: [],
      orderDefineList: [{
        id: -1,
        name: '需用量表'
      }],
      accountType: ['主材', '辅材', '软装'],
      priceList: [],
      title: '新增',
      orderType: false,
      classifyInfo: {},
      red: false,
      notRed: false
    }
  },
  created () {
    this.getMenuList()
    this.axios.post('materialPrice/getPriceList').then(res => {
      if (res.data.success) {
        this.priceList = res.data.data
      } else {
        this.$message({
          message: res.data.msg,
          type: 'error',
          offset: 400
        })
      }
    })
  },
  mounted () {},
  methods: {
    getMenuList () {
      this.menuList = []
      this.axios.post('orderDefine/list', {companyId: this.$store.state.companyId}).then(res => {
        if (res.data.success) {
          this.menuList = res.data.data
          this.chooseMenuId = this.menuList[0].id
          this.currentMenu = this.menuList[0]
          this.orderDefineList = this.orderDefineList.concat(res.data.data)
          this.getData()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    cancelBackOrder () {
      this.data.chargebackOrder = ' '
      this.data.chargebackOrderId = -1
    },
    onSave () {
      if (this.data.sourceOrderId) {
        for (let i = 0; i < this.orderDefineList.length; i++) {
          if (this.orderDefineList[i].id === this.data.sourceOrderId) {
            this.data.sourceOrder = this.orderDefineList[i].name
            break
          }
        }
      }
      if (this.data.costPriceField) {
        for (let i = 0; i < this.priceList.length; i++) {
          if (this.priceList[i].priceField === this.data.costPriceField) {
            this.data.costPriceName = this.priceList[i].name
            break
          }
        }
      }
      if (this.data.customerPriceField) {
        for (let i = 0; i < this.priceList.length; i++) {
          if (this.priceList[i].priceField === this.data.customerPriceField) {
            this.data.customerPriceName = this.priceList[i].name
            break
          }
        }
      }
      if (this.data.accountingTypeName) {
        if (this.data.accountingTypeName === '辅材') {
          this.data.accountingType = 'auxiliary'
        } else if (this.data.accountingTypeName === '主材') {
          this.data.accountingType = 'project'
        } else if (this.data.accountingTypeName === '软装') {
          this.data.accountingType = 'soft'
        }
      }
      this.axios.post('orderDefine/modify', this.data).then(res => {
        if (res.data.success) {
          this.$message.success('定义成功！')
          this.getMenuList()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getData () {
      this.data = {}
      this.axios.post('orderDefine/getById', this.qs.stringify({id: this.currentMenu.id})).then(res => {
        if (res.data.success) {
          let list = res.data.data
          if (list.accountingType === 'auxiliary') {
            list.accountingTypeName = '辅材'
          } else if (list.accountingType === 'project') {
            list.accountingTypeName = '主材'
          } else if (list.accountingType === 'soft') {
            list.accountingTypeName = '软装'
          }
          this.data = list
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onChooseMenu (menu) {
      if (menu.id !== this.chooseMenuId) {
        this.chooseMenuId = menu.id
        this.currentMenu = menu
        this.getData()
      }
    },
    onDeleteClassify (menu) {
      let that = this
      this.$confirm('此操作将永久删除该类别, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('orderDefine/deleteById', that.qs.stringify({id: menu.id})).then(res => {
          if (res.data.success) {
            this.getMenuList()
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
            that.$message({
              type: 'error',
              message: res.data.msg,
              offset: 400
            })
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    addOrderType () {
      this.orderType = true
      this.classifyInfo = {}
      this.red = false
      this.notRed = false
    },
    onChange1 (e) {
      this.red = e
      this.notRed = !e
    },
    onChange2 (e) {
      this.red = !e
      this.notRed = e
    },
    submitClassify () {
      console.log(this.classifyInfo)
      this.classifyInfo.companyId = this.$store.state.companyId
      this.classifyInfo.isRed = this.red ? -1 : this.notRed ? 1 : null
      if (!this.classifyInfo.isRed) {
        this.$message.warning('请选择是否是正单')
      } else if (!this.classifyInfo.name) {
        this.$message.warning('请将单据名称补充完整')
      } else if (!this.classifyInfo.orderCode) {
        this.$message.warning('请将编码方案补充完整')
      } else if (!this.classifyInfo.type) {
        this.$message.warning('请将单据类型补充完整')
      } else if (!this.classifyInfo.storehouseFlag) {
        this.$message.warning('请将是否库存单补充完整')
      } else if (!this.classifyInfo.permission) {
        this.$message.warning('请将单据权限补充完整')
      } else if (!this.classifyInfo.accountingTypeName) {
        this.$message.warning('请选择记账类型')
      } else if (!this.classifyInfo.costPriceField) {
        this.$message.warning('请选择采购价/成本价')
      } else if (!this.classifyInfo.customerPriceField) {
        this.$message.warning('请选择销售价')
      } else {
        if (this.classifyInfo.accountingTypeName) {
          if (this.classifyInfo.accountingTypeName === '辅材') {
            this.classifyInfo.accountingType = 'auxiliary'
          } else if (this.classifyInfo.accountingTypeName === '主材') {
            this.classifyInfo.accountingType = 'project'
          } else if (this.classifyInfo.accountingTypeName === '软装') {
            this.classifyInfo.accountingType = 'soft'
          }
        }
        let url = 'orderDefine/save'
        this.axios.post(url, this.classifyInfo).then(res => {
          if (res.data.success) {
            this.orderType = false
            this.$message.success(this.title + '成功')
            this.classifyInfo = {}
            this.getMenuList()
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }
    },
    resetClassify () {
      this.classifyInfo = {}
      this.isRed = null
    }
  }
}
</script>

<style lang="scss" scoped>
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    cursor: pointer;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #46b8b0;
    border-radius: 4px;
  }
  .tip-16-round-30313a {
    height: 16px;
    line-height: 16px;
    padding: 0 10px;
    color: #ffffff;
    font-size: 12px;
    background: #30313a;
    border-radius: 99px;
  }
   .require-tip {
    position: absolute;
    left: -10px;
    color: #ff5555;
    top: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/materialOrderDefine.vue